import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import {mobile_validation,password_validation,otp_validation} from '../../../../../../utils/validations'
import {http_request} from '../../../../../../utils/http_request'
import {endpoint} from '../../../../../../config'
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import {LoaderContext} from '../../../../../../context/LoaderContext'
import {SnackBarContext} from '../../../../../../context/SnackBarContext'
import {Spinner} from '../../../../../../utils/spinner'
import {do_student_login} from '../../../authentication'
export default(props)=>{

const loader=React.useContext(LoaderContext);
const snackBar=React.useContext(SnackBarContext)
  return(
    <App   {...props} loader={loader} snackBar={snackBar}/>
  )
}
 class App   extends React.Component {

    state = {
        user: {
            mobile: '',
            password: '',
            otp:''
        },
        show_otp_form:false,
        submittingRegister:false,
        submittingOTP:false


    };

    componentDidMount() {
        // custom rule will have name 'isValidMobile'
        ValidatorForm.addValidationRule('isValidMobile', (value) => {
          return mobile_validation(value)
        });
		ValidatorForm.addValidationRule('isValidPassword', (value) => {
            return password_validation(value)
        });
        ValidatorForm.addValidationRule('isValidOTP', (value) => {
                return otp_validation(value)
            });


    }

    componentWillUnmount() {
        // remove rule when it is not needed
        ValidatorForm.removeValidationRule('isValidMobile');
		ValidatorForm.removeValidationRule('isValidPassword');
    }

    handleChange = (event) => {
        const { user } = this.state;
        user[event.target.name] = event.target.value;
        this.setState({ user });
    }

    handleSubmit = async() => {
try{



      this.setState({submittingRegister:true})
const {mobile:username}=this.state.user
    const {data}=  await http_request({endpoint:endpoint,service:'register',variables:`username=${username}`})

 if(data.success){
this.props.snackBar.show(data.message)
 this.setState({show_otp_form:true})
 var user = {...this.state.user}
user.otp = '';

this.setState({user})
 }
      }
      catch(e){
this.props.snackBar.show(e.message)
      }
      finally{
      this.setState({submittingRegister:false})



      }
    }


handleSubmitOTP=async ()=>{

  try{

      this.setState({submittingOTP:true})

  const {mobile:username,password:pwd,otp}=this.state.user;

      const {data}=  await http_request({endpoint:endpoint,service:'verify-otp',variables:`username=${username}&otp=${otp}`})
   if(data.success){
{
  do_student_login(data.token);
  this.props.handleClose()
setTimeout(()=>{
    this.props.post_fn()
},500)


}


   }
        }
        catch(e){
this.props.snackBar.show(e.message)
        }
        finally{
      this.setState({submittingOTP:false})

      }
      }

    handleResendOTP = async() => {
try{



const {mobile:username,password:pwd}=this.state.user
    const {data}=  await http_request({endpoint:endpoint,service:'resend-otp',variables:`username=${username}`})

 if(data.success){
this.props.snackBar.show(data.message)
 }
      }
      catch(e){
this.props.snackBar.show(e.message)
      }
      finally{


    }
    }



    render() {
        const { user ,show_otp_form,submittingRegister,submittingOTP} = this.state;

        return (
<>
{
  !show_otp_form &&
<>
            <ValidatorForm
                onSubmit={this.handleSubmit}
            >
                <TextValidator

					margin="normal"

					fullWidth
					autoFocus
                    label="Mobile"
                    onChange={this.handleChange}
                    name="mobile"
                    type="tel"
                    validators={['required','isValidMobile']}
                    errorMessages={['mobile number is required','please enter correct mobile number']}
                    value={user.mobile}
                />
				 <br />

                <Button  type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={submittingRegister}
             >
             {submittingRegister?"Submitting":"Submit"}
{submittingRegister && <>&nbsp;&nbsp;<Spinner/></>}
             </Button>
            </ValidatorForm>
            <br />

            </>
          }

{
  show_otp_form &&    <> <ValidatorForm
          onSubmit={this.handleSubmitOTP}
      >
          <TextValidator

    margin="normal"

    fullWidth
    autoFocus
              label="One Time Password (OTP)"
              onChange={this.handleChange}
              name="otp"
              type="tel"
              validators={['required','isValidOTP']}
              errorMessages={['otp is required','invalid otp']}
              value={user.otp}
          />

  <br/>

          <Button  type="submit"
      fullWidth
      variant="contained"
      color="primary"
        disabled={submittingOTP}
       >
       {submittingOTP?"Verifying OTP":"Verify OTP"}
{submittingOTP && <>&nbsp;&nbsp;<Spinner/></>}

       </Button>
       <br />
       <Button  type="submit"
   fullWidth
onClick={()=>this.setState({show_otp_form:false})}
   color="primary"
    >Change Mobile Number</Button>
      </ValidatorForm>

      <Grid container  >

        <Grid item>
          <Button  onClick={this.handleResendOTP}  >
            {"Resend OTP?"}
          </Button>
        </Grid>
      </Grid>
      </>

}
</>





        );
    }

}
